import UserFilter from './UserFilterController';
import type {Filters} from './UserFilterController';

export type {Filters};
export default UserFilter;
